'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $scope, Upload, toaster, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$scope = $scope;
    this.Upload = Upload;
    this.toaster = toaster;
    this.$stateParams = $stateParams;

    this.font = {};
  }

  $onInit() {
    this.getFont(this.$stateParams.id);
    this.getList();
  }

  getFont(id) {
    this.$http.get(`/api/fonts/${id}`).then(res => {
      this.font = res.data;
    });
  }

  upload(file) {
    if (!file) {
      this.update()
      return
    }
    this.toaster.pop({
      type: 'wait',
      title: '正在上传，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: '/api/fonts/uploadFile',
      file: file,
      data: this.font,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.$state.go('fonts');
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  update() {
    this.$http.put(`/api/fonts/${this.$stateParams.id}`, this.font).then(res => {
      this.$state.go('fonts');
    });
  }

  getList() {
    this.$http.get('/api/AppConfGroups').then(res => {
      this.groups = res.data;
    });
  }

  toggleSelection(id) {
    let idx = this.font.modelGroups.indexOf(id);
    if (idx > -1) {
      this.font.modelGroups.splice(idx, 1);
    } else {
      this.font.modelGroups.push(id);
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/fonts/edit/edit.controller.js